// Public API client entry. The app imports `callApi` (and friends) from here. The implementation
// lives in the worker connector; this module is the stable import surface (replacing the old
// `api/gramjs` re-export shim from the MTProto era).
export {
  initApi, callApi, cancelApiProgress, cancelApiProgressMaster, callApiLocal,
  handleMethodCallback,
  handleMethodResponse,
  updateFullLocalDb,
  updateLocalDb,
  setShouldEnableDebugLog,
} from './worker/connector';
